import {
  Search,
  Edit,
  Clock,
  Mail,
  FileQuestion,
  CheckCircle2,
  XCircle,
} from 'lucide-react';
import { CustomerStatus, StatusConfig } from './types';

// Status configuration
export const STATUS_CONFIG: Record<CustomerStatus, StatusConfig> = {
  all: {
    label: 'All',
    icon: Search,
    bgColor: 'bg-gray-100 hover:bg-gray-200',
    textColor: 'text-gray-800',
    badgeColor: 'bg-gray-500 text-white',
  },
  draft: {
    label: 'Draft',
    icon: Edit,
    bgColor: 'bg-blue-50 hover:bg-blue-100',
    textColor: 'text-blue-800',
    badgeColor: 'bg-blue-500 text-white',
  },
  pending_initial: {
    label: 'Pending Initial Approval (pre invite)',
    icon: Clock,
    bgColor: 'bg-yellow-50 hover:bg-yellow-100',
    textColor: 'text-yellow-800',
    badgeColor: 'bg-yellow-500 text-white',
  },
  invited: {
    label: 'Invited',
    icon: Mail,
    bgColor: 'bg-gray-50 hover:bg-gray-100',
    textColor: 'text-gray-800',
    badgeColor: 'bg-gray-600 text-white',
  },
  due_diligence: {
    label: 'Pending Approval (Due Diligence)',
    icon: FileQuestion,
    bgColor: 'bg-indigo-50 hover:bg-indigo-100',
    textColor: 'text-indigo-800',
    badgeColor: 'bg-indigo-500 text-white',
  },
  approved: {
    label: 'Approved',
    icon: CheckCircle2,
    bgColor: 'bg-green-50 hover:bg-green-100',
    textColor: 'text-green-800',
    badgeColor: 'bg-green-500 text-white',
  },
  not_approved: {
    label: 'Not Approved',
    icon: XCircle,
    bgColor: 'bg-red-50 hover:bg-red-100',
    textColor: 'text-red-800',
    badgeColor: 'bg-red-500 text-white',
  },
  // 'renewal_due' was a dead onboarding_status — renewal is tracked per-questionnaire
  // on the customer card's compliance badge, not on the onboarding status itself.
  // Once approved, customers stay approved independent of questionnaire freshness.
};
